module.exports = __webpack_public_path__ + "img/已下架.f0fa2b38.png";